import { CommonRootState } from '../redux';

import { CollabManager } from './collab-manager';

export function selectCollabManagerByContentId(
  state: CommonRootState,
  { contentId }: { contentId: string }
): CollabManager | undefined {
  return state.collab.byContentId[contentId];
}
